<script setup>
import {useRouter} from 'vue-router';
import ProjectInfo from "@/components/common/ProjectInfo.vue";
import ProjectMap from "@/components/common/ProjectMap.vue";

const router = useRouter()

function goProjectView() {
  router.push({name: 'ArchitectDashboard'})
}

</script>

<template>
  <ProjectInfo/>
  <v-card class="default-card pa-6" elevation="3">
    <v-card-title class="toolbox-card-title">
      {{ $t('functionalities.projectInfo.tabs.map') }}
    </v-card-title>
    <ProjectMap/>
  </v-card>

  <v-card-actions class="card-actions">
    <v-spacer></v-spacer>
    <v-btn color="secondary" variant="flat" @click="goProjectView">
      {{ $t('backTo') }} {{ $t('titles.dashboard') }}
    </v-btn>
  </v-card-actions>

</template>

<style scoped>
@import '@/assets/styles/views/Architect/ProjectInformation/ProjectInformationView.css';
@import '@/assets/styles/views/HomeView.css';
</style>
